import { useTranslation } from "react-i18next";
import { withSidebar } from "../hoc/withSidebar";
import { Box, Typography } from "../primitives";

const NewBillerCrossReference = () => {
  const { t } = useTranslation();
  return (
    <Box ml={3} mt={2} role="main">
      <Typography variant="h1">
        {t("erps.billermanagement.crossreference.new.page.title")}
      </Typography>
    </Box>
  );
};

export default withSidebar(NewBillerCrossReference);
